import styled, { css } from "styled-components";

import { FormElement } from "../shared-style";
import { IStyleProps } from "./interfaces";

export const StyledRadio = styled(FormElement)`
    &:focus {
        outline: 0;
    }
`;

export const RadioOption = styled.div`
    font-weight: 300;
    font-size: 18px;
    padding-left: 24px;
    position: relative;
    margin-bottom: 6px;
    cursor: pointer;

    &.Disabled {
        color: ${p => p.theme.c.disabled};
        cursor: default;
    }
`;

export const Marker = styled.div<IStyleProps>`
    width: 16px;
    height: 16px;
    ${p =>
        p.selected
            ? css`
                  border: 2px solid ${p => p.theme.c.active};
                  &.Disabled {
                      border-color: ${p => p.theme.c.disabled};
                  }
              `
            : css`
                  border: 1px solid ${p => p.theme.c.dark};
                  &.Disabled {
                      border-color: ${p => p.theme.c.disabled};
                  }
              `}
    border-radius: 8px;
    box-sizing: border-box;
    position: absolute;
    top: 4px;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
`;

export const Center = styled.div<IStyleProps>`
    width: 6px;
    height: 6px;
    border-radius: 3px;
    ${p =>
        p.selected
            ? css`
                  background-color: ${p => p.theme.c.active};
                  &.Disabled {
                      background-color: ${p => p.theme.c.disabled};
                  }
              `
            : undefined}
    box-sizing: border-box;
`;
